var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFilterSettingtsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4.5C2.5 5.05228 2.94772 5.5 3.5 5.5C4.05228 5.5 4.5 5.05228 4.5 4.5C4.5 3.94772 4.05228 3.5 3.5 3.5C2.94772 3.5 2.5 3.94772 2.5 4.5ZM1 4.5C1 5.88071 2.11929 7 3.5 7C4.61995 7 5.56789 6.26357 5.88601 5.24854C5.90162 5.24951 5.91735 5.25 5.93321 5.25H14C14.4142 5.25 14.75 4.91422 14.75 4.5C14.75 4.08579 14.4142 3.75 14 3.75H5.93321C5.91736 3.75 5.90162 3.7505 5.88601 3.75146C5.5679 2.73643 4.61995 2 3.5 2C2.11929 2 1 3.11929 1 4.5ZM2 10.75C1.58579 10.75 1.25 11.0858 1.25 11.5C1.25 11.9142 1.58579 12.25 2 12.25H10.1145C10.433 13.2643 11.3806 14 12.5 14C13.8807 14 15 12.8807 15 11.5C15 10.1193 13.8807 9 12.5 9C11.3806 9 10.433 9.73572 10.1145 10.75H2ZM12.5 12.5C13.0523 12.5 13.5 12.0523 13.5 11.5C13.5 10.9477 13.0523 10.5 12.5 10.5C11.9477 10.5 11.5 10.9477 11.5 11.5C11.5 12.0523 11.9477 12.5 12.5 12.5Z",
    fill: "#002CFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterSettingtsActive);
export default __webpack_public_path__ + "static/media/iconFilterSettingtsActive.1a0920d1b274bca2c20436dafce11678.svg";
export { ForwardRef as ReactComponent };